<script>

export default {

    name: "BuyTokens",
    data() {
        return {
            step: 1,
            error: '',
            errors: {},
            loading: false,
            data: {
                token_amount: '',
                company_name: this.$auth.user?.company?.name || '',
                bank_account_number: this.$auth.user?.bank_account_number || '',
                nip: this.$auth.user?.company?.nip || ''
            }
        }
    },
    methods: {
        next() {
            this.step = 2;
        },
        previous() {
            this.step = 1;
        },
        submit() {
            this.loading = true;
            axios.post('/token-purchases', this.data).then(() => {
                this.step = 3;
            }).catch((data) => {
                console.log(data);
                this.step = 1;
                this.errors = data.response?.data?.errors || {};
                if (data.status === 500) {
                    this.$toast.error(this.$t('messages.error_try_again'))
                }
            }).finally(() => {
                this.loading = false;
            })
        }
    }
}

</script>
<template>
    <div class="buy-tokens">
        <div class="step-1 content" v-if="step === 1">
            <form @submit.prevent="next">

                <b-field :label="$t('token_purchases.fields.token_amount.name')" custom-class="mb-3"
                         :type="errors.token_amount ? 'is-danger' : null"
                         :message="errors.token_amount ? errors.token_amount[0] : null">
                    <b-input
                        type="number"
                        v-model="data.token_amount"
                        icon="cash-multiple"
                        required
                    ></b-input>
                </b-field>

                <b-field :label="$t('companies.fields.name.name')" custom-class="mb-3"
                         label-for="company_name"
                         :type="errors.company_name ? 'is-danger' : null"
                         :message="errors.company_name ? errors.company_name[0] : null">
                    <b-input
                        id="company_name"
                        v-model="data.company_name"
                        icon="domain"
                        required
                    ></b-input>
                </b-field>

                <b-field :label="$t('companies.fields.nip.name')"  custom-class="mb-3"
                         label-for="nip"
                         :type="errors.nip ? 'is-danger' : null"
                         :message="errors.nip ? errors.nip[0] : null">
                    <b-input
                        id="nip"
                        v-model="data.nip"
                        icon="card-account-details-outline"
                        required
                    ></b-input>
                </b-field>

                <b-field :label="$t('token_purchases.fields.bank_account_number.label')"
                         custom-class="mb-3"
                         label-for="bank_account_number"
                         :type="errors.bank_account_number ? 'is-danger' : null"
                         :message="errors.bank_account_number ? errors.bank_account_number[0] : null">
                    <b-input
                        v-model="data.bank_account_number"
                        icon="bank"
                        required
                    ></b-input>
                </b-field>

                <section>
                    <button class="button is-primary" type="submit">
                        {{ $t('actions.next') }}
                    </button>
                </section>
            </form>
        </div>
        <div class="step-2 content" v-if="step === 2">
            <p>
                <strong>{{ $t('token_purchases.labels.transfer_details') }}:</strong>
            </p>

            <blockquote>
                <p>{{ $t('companies.fields.name.name') }}</p>
                <p>{{ $t('token_purchases.fields.bank_account_number.name') }}: 0000 0000 0000 0000 0000</p>
                <p>{{ $t('token_purchases.fields.token_amount.name') }}: {{ data.token_amount }}</p>
            </blockquote>

            <br>
            <p>{{ $t('token_purchases.messages.tokens_send_after_transfer_info') }}</p>

            <div class="buttons mt-5">
                <b-button type="is-primary"
                          native-type="submit"
                          @click="submit"
                          :disabled="loading"
                          :loading="loading">
                    {{ $t('actions.send') }}
                </b-button>

                <b-button @click="previous" :loading="loading">
                    {{ $t('actions.back') }}
                </b-button>
            </div>
        </div>
        <div class="step-3 content" v-if="step === 3">
            <p>{{ $t('token_purchases.messages.transfer_deadline_notice') }}</p>
            <p>{{ $t('token_purchases.messages.token_delivery_notice') }}</p>
        </div>
    </div>
</template>
